export default {
  /// Nhà trẻ
  KinderGarden: 12,

  /// Mẫu giáo
  Hope: 11,

  /// Mầm non
  PlaySchool: 0,

  /// Tiểu học
  Elementary: 1,

  /// THCS
  Junior: 2,

  /// THPT
  Senior: 3,

  /// Trường liên cấp 1,2
  LienCap12: 4,

  /// Trường liên cấp 2,3
  LienCap23: 5,

  /// Trường liên cấp 1,2,3
  LienCap123: 6,

  /// Trường Trung cấp chuyên nghiệp
  TrungCapCN: 7,
}
